import {
  TextField,
  DropDown,
  DropDownInputLabel,
  formFieldRequiredLabel as requiredLabel,
  PasswordField,
} from '@elementary/common-ui/components';
import FormControls from '@elementary/common-ui/components/FormControls';
import { FormControl } from '@mui/material';
import { UseFormReturn } from 'react-hook-form';
import { SigmaForm as SigmaFormFields, SigmaCloudProvider } from 'shared/types';

const cloudProviderOptions = [
  { value: SigmaCloudProvider.AWS_US, label: 'AWS (US)' },
  { value: SigmaCloudProvider.AWS_Canada, label: 'AWS Canada' },
  { value: SigmaCloudProvider.AWS_Europe, label: 'AWS Europe' },
  { value: SigmaCloudProvider.AWS_UK, label: 'AWS UK' },
  { value: SigmaCloudProvider.Azure_US, label: 'Azure US' },
  { value: SigmaCloudProvider.GCP, label: 'GCP' },
];

const SigmaDialogForm = ({
  formMethods,
}: {
  formMethods: UseFormReturn<SigmaFormFields, any, undefined>;
}) => {
  const {
    register,
    formState: { errors, dirtyFields },
    setValue,
    watch,
  } = formMethods;

  return (
    <>
      <FormControls.InputWrapper>
        <TextField
          {...register('sigmaConnectionName', {
            required: requiredLabel,
          })}
          variant="outlined"
          label="Connection name"
          size="large"
        />
        <FormControls.ErrorMessage>
          {errors.sigmaConnectionName?.message}
        </FormControls.ErrorMessage>
      </FormControls.InputWrapper>

      <FormControl>
        <DropDownInputLabel size="medium" style={{ top: 0 }}>
          Cloud provider
        </DropDownInputLabel>
        <DropDown
          sx={{ height: '56px !important' }}
          {...register('sigmaCloudProvider', {
            required: requiredLabel,
          })}
          variant="outlined"
          value={watch('sigmaCloudProvider')}
          onChange={(value) => setValue('sigmaCloudProvider', value)}
          options={cloudProviderOptions}
          size="large"
        />
      </FormControl>

      <FormControls.InputWrapper>
        <TextField
          {...register('sigmaClientId', {
            required: requiredLabel,
          })}
          variant="outlined"
          label="Client ID"
          size="large"
        />
        <FormControls.ErrorMessage>
          {errors.sigmaClientId?.message}
        </FormControls.ErrorMessage>
      </FormControls.InputWrapper>

      <FormControls.InputWrapper>
        <PasswordField
          {...register('sigmaClientSecret', {
            required: requiredLabel,
          })}
          variant="outlined"
          label="Client secret"
          isFormValueDirty={dirtyFields.sigmaClientSecret}
          clearFormValue={() => setValue('sigmaClientSecret', '')}
          size="large"
        />
        <FormControls.ErrorMessage>
          {errors.sigmaClientSecret?.message}
        </FormControls.ErrorMessage>
      </FormControls.InputWrapper>
    </>
  );
};

export default SigmaDialogForm;
